<div class="login-container">
  <div class="login-card">
    <div class="login-card-isotipo">
      <img src="img/logo.png" alt="" srcset="">
    </div>
    
    <div class="p-inputgroup">
      <span class="p-inputgroup-addon">
        <i class="pi pi-key"></i>
      </span>
      <label class="login-subtitle"><span class="arrow-colored">←</span> Ingresa el código de verificación</label>
    </div>
    <p class="login-description">Hemos enviado el código al correo registrado, escríbelo aquí para crear tu cuenta.</p>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="input-group">
        <label class="input-label">Código de verificación</label>
        <p-password 
          formControlName="code"
          [toggleMask]="false"
          [feedback]="false"
          placeholder="0000"
          class="custom-input"
          [inputStyleClass]="submitted && f['code'].errors ? 'custom-input input-error' : 'custom-input'"
          [maxlength]="4"
          (input)="onCodeInput($event)"
        ></p-password>
        <i class="pi pi-lock input-icon"></i>
        <div *ngIf="submitted && f['code'].errors" class="error-message">
          <div *ngIf="f['code'].errors['required']">Código requerido</div>
          <div *ngIf="f['code'].errors['minlength']">4 caracteres</div>
        </div>
      </div>

      <button
        pButton
        type="submit"
        class="login-button"
        [disabled]="loginForm.invalid && submitted"
      >
        Verificar código
      </button>
      <button
        pButton
        type="button"
        class="login-button login-send"
        [disabled]="isCountdownActive || (loginForm.invalid && submitted)"
        (click)="resendCode()"
      >
        {{ isCountdownActive ? ('Reenviar código ' + countdown) : 'Reenviar código' }}
      </button>
    </form>
  </div>
</div>